import React from 'react';
import { Box, Typography, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { OrganizationAccreditationConfig } from '../../../_types/accreditation';

interface EditProps {
  config: OrganizationAccreditationConfig;
  productLevels: string[];
  onChange: (config: OrganizationAccreditationConfig) => void;
}

const Edit: React.FC<EditProps> = ({ config, productLevels, onChange }) => {
  const handleDateChange = (newValue: dayjs.Dayjs | null) => {
    const updatedConfig = {
      ...config,
      expirationAt: newValue && newValue.isValid() ? newValue.toISOString() : null,
    };
    onChange(updatedConfig);
  };

  const handleLevelChange = (_event: React.ChangeEvent<HTMLInputElement>, value: string) => {
    const updatedConfig = {
      ...config,
      productLevel: value,
    };
    onChange(updatedConfig);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <Box>
        <Typography
          variant='subtitleSm'
          sx={{ mb: 1 }}
        >
          {t('manageSolutions.accreditation.planExpiration')}
        </Typography>
        <DatePicker
          sx={{ width: 260 }}
          value={config.expirationAt && dayjs(config.expirationAt).isValid() ? dayjs(config.expirationAt) : null}
          onChange={handleDateChange}
          minDate={dayjs().add(1, 'day').startOf('day')}
          slotProps={{
            field: { clearable: true, onClear: () => handleDateChange(null) },
            textField: {
              size: 'small',
              fullWidth: true,
              sx: {
                '&.MuiFormControl-root': {
                  paddingTop: 0,
                },
              },
            },
          }}
        />
      </Box>

      <Box>
        <Typography
          variant='subtitleSm'
          sx={{ mb: 3 }}
        >
          {t('manageSolutions.accreditation.subscriptionType')}
        </Typography>
        <RadioGroup
          row
          value={config.productLevel || ''}
          onChange={handleLevelChange}
        >
          {productLevels.map((item) => (
            <FormControlLabel
              value={item}
              control={<Radio />}
              label={item}
              key={item}
            />
          ))}
        </RadioGroup>
      </Box>
    </Box>
  );
};

export default Edit;
